import React, { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Box,
  createStyles,
  ListItemText,
  makeStyles,
  MenuItem,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { Menu, Button } from 'new-design/common/ui';
import { ArrowDownIcon, ArrowUpIcon, BranchIcon } from 'assets/icons';
import * as globalContext from 'ducks/globalContext';
import * as auth from 'ducks/auth';
import { getBranchesOptions } from 'app/selectors/genericSelector';
import { formatBranchShortName } from 'util/formatting';
import { UserTypes } from 'ducks/roles/types';

export const useStyles = makeStyles(
  (theme) =>
    createStyles({
      arrowDown: {
        '& path': {
          stroke: '#222',
        },
      },
      menuItem: {
        display: 'flex',
        alignItems: 'center',

        '& .MuiButton-startIcon': {
          margin: 0,
        },
        [theme.breakpoints.down('lg')]: {
          '& .MuiTypography-body1': {
            fontSize: 14,
            lineHeight: '19px',
          },
        },
      },
      branchSelectorMenu: {
        marginTop: 30,
      },
      branchIcon: {
        '& path': {
          fill: theme.palette.secondary.main,
        },
      },
    }),
  { name: 'BranchSelector' }
);

export const BranchSelector = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const { setBranchID } = bindActionCreators(globalContext.actions, useDispatch());

  const { userInfo } = useSelector(auth.selectors);
  const { branchID } = useSelector(globalContext.selectors);
  const branchesOptions = useSelector(getBranchesOptions);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const canChangeBranch = useMemo(() => {
    return userInfo.userType === UserTypes.ADMINISTRATOR;
  }, [userInfo.userType]);

  const selectedBranch = useMemo(() => {
    return branchesOptions.find(({ key }) => key === branchID);
  }, [branchID, branchesOptions]);

  const handleModalOpen = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleModalClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleBranchChange = useCallback(
    (branchID) => {
      setBranchID(branchID);
      history.replace(location.pathname);
    },
    [location?.pathname]
  );

  return (
    <>
      <Tooltip title={selectedBranch?.label}>
        <Button
          aria-controls="customized-menu-langswitcher"
          aria-haspopup="true"
          variant="text"
          color="secondary"
          className={classes.itemsInCenter}
          onClick={canChangeBranch && handleModalOpen}
          startIcon={<BranchIcon className={classes.branchIcon} />}
          endIcon={
            canChangeBranch ? (
              anchorEl ? (
                <ArrowUpIcon />
              ) : (
                <ArrowDownIcon className={classes.arrowDown} />
              )
            ) : null
          }
        >
          <Box ml={1}>
            <Typography>{formatBranchShortName(selectedBranch?.label)}</Typography>
          </Box>
        </Button>
      </Tooltip>
      <Menu
        id="customized-menu-langswitcher"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleModalClose}
        className={classes.branchSelectorMenu}
      >
        {branchesOptions.map(({ key, label }) => (
          <MenuItem key={key} onClick={() => handleBranchChange(key)} className={classes.menuItem}>
            <ListItemText primary={label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
